import useAppQuery from 'core/query-client/useAppQuery';
import { getRecentSites } from 'shared/api/projects/http';

const useRecentSitesQuery = () => useAppQuery('recent-sites', getRecentSites);

export default useRecentSitesQuery;
